import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { Field } from 'react-final-form';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FormFragmentContext } from '../containers/Fragment';
import getAutoComplete from '../containers/AutoComplete';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles({
  hideAsterisk: {
    display: 'none'
  }
}, {
  name: 'ECFormFieldBase'
});
/**
 * @param {import('./types').FormFieldBase} props
 */

var FormFieldBase = function FormFieldBase(_ref) {
  var autoComplete = _ref.autoComplete,
      injectLabel = _ref.injectLabel,
      props = _objectWithoutProperties(_ref, ["autoComplete", "injectLabel"]);

  var context = React.useContext(FormFragmentContext);
  var classes = useStyles();

  var variant = props.variant,
      disabled = props.disabled,
      color = props.color,
      labelVariant = props.labelVariant,
      labelPlacement = props.labelPlacement,
      required = props.required,
      validate = props.validate,
      hideAsterisk = props.hideAsterisk,
      rest = _objectWithoutProperties(props, ["variant", "disabled", "color", "labelVariant", "labelPlacement", "required", "validate", "hideAsterisk"]);

  variant = variant || context.variant;
  disabled = disabled || context.disabled;
  color = color || context.color;
  labelPlacement = labelPlacement || context.labelPlacement;
  labelVariant = labelVariant || context.labelVariant || 'body2';
  if (variant === 'filled') labelPlacement = labelPlacement || 'start';else labelPlacement = 'top';

  var validateWithRequired = function validateWithRequired(value) {
    var error = validate && validate(value);

    if (!error) {
      if (typeof required !== 'undefined') {
        if (props.type === 'checkbox' || props.type === 'radio') {
          //follows HTML specs, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Client-side_validation
          if (required && value === null) return 'Field is required';
          if (required === true && value === false) return 'Field must be checked';
          if (required === false && value === true) return 'Field must be unchecked';
        } else {
          //other fields, including text
          if (required && !value) return 'Field is required';
        }
      }
    }

    return error;
  };

  var autoCompleteInfo = getAutoComplete(autoComplete);
  var field = React.createElement(React.Fragment, null, React.createElement(Field, Object.assign({
    id: props.name,
    variant: variant,
    disabled: disabled,
    color: color,
    required: required,
    validate: validateWithRequired
  }, autoCompleteInfo.inputProps, rest)), autoCompleteInfo.dataList);
  var hasLabel = false;
  if (injectLabel === 'auto') hasLabel = Boolean(variant === 'filled' && props.label);else hasLabel = injectLabel;

  if (hasLabel) {
    var LABEL_SIZE = 4;
    var hideLabel = false;
    if (props.type === 'checkbox') hideLabel = true;
    return React.createElement(Grid, {
      container: true,
      direction: labelPlacement === 'top' ? 'column' : 'row'
    }, !hideLabel && React.createElement(Grid, {
      item: true,
      xs: labelPlacement === 'top' ? 12 : LABEL_SIZE
    }, React.createElement(Field, {
      name: props.name,
      subscription: {
        touched: true,
        error: true
      }
    }, function (_ref2) {
      var meta = _ref2.meta;
      return React.createElement(InputLabel, {
        shrink: variant === 'standard',
        htmlFor: props.name,
        error: !!(meta.touched && meta.error),
        required: required,
        disabled: disabled,
        style: {
          marginTop: 26,
          display: 'block'
        },
        classes: hideAsterisk ? {
          asterisk: classes.hideAsterisk
        } : {}
      }, React.createElement(Typography, {
        display: "inline",
        variant: labelVariant,
        color: "inherit",
        style: {
          marginBottom: 0
        }
      }, props.label));
    })), React.createElement(Grid, {
      item: true,
      xs: labelPlacement === 'top' ? 12 : 12 - LABEL_SIZE
    }, field));
  }

  return field;
};

FormFieldBase.defaultProps = {
  /** set to `true` to render a label or `false` to hide  */
  injectLabel: 'auto',
  hideAsterisk: false
};
export default FormFieldBase;